import { useEffect, useState } from "react"

export const installCommand = "curl -fsSL https://codiano.pages.dev/install.sh | /bin/bash"

type Platform = "checking" | "mac" | "windows" | "other"

export const detectPlatform = (navigator: Navigator): Platform => {
  const navigatorWithData = navigator as Navigator & { userAgentData?: { platform?: string } }
  const value = [navigatorWithData.userAgentData?.platform, navigator.platform, navigator.userAgent]
    .filter(Boolean)
    .join(" ")

  if (/iphone|ipad|ipod/i.test(value)) return "other"
  if (/MacIntel/i.test(navigator.platform) && navigator.maxTouchPoints > 1) return "other"
  if (/mac/i.test(value)) return "mac"
  if (/win/i.test(value)) return "windows"
  return "other"
}

const Download = ({ platform }: { platform: Platform }) => {
  const [copied, setCopied] = useState(false)

  if (platform === "mac") {
    const copyInstallCommand = async () => {
      await navigator.clipboard.writeText(installCommand)
      setCopied(true)
      window.setTimeout(() => setCopied(false), 2400)
    }

    return (
      <button
        aria-label="Copy Mac install command"
        className="download download--command"
        onClick={() => void copyInstallCommand()}
        type="button"
      >
        <code>{installCommand}</code>
        <span aria-hidden="true">{copied ? "COPIED ✓" : "COPY"}</span>
      </button>
    )
  }

  const label = {
    checking: "CHECKING DEVICE…",
    windows: "WINDOWS BUILD NOT AVAILABLE",
    other: "OPEN ON A MAC TO DOWNLOAD",
  }[platform]

  return (
    <button className="download download--disabled" disabled type="button">
      {label}
    </button>
  )
}

export const App = () => {
  const [platform, setPlatform] = useState<Platform>("checking")

  useEffect(() => setPlatform(detectPlatform(navigator)), [])

  return (
    <div className="site-shell">
      <div aria-hidden="true" className="scanline" />

      <header className="site-header">
        <a className="wordmark" href="#top">
          <span className="status-dot" />
          CODIANO
        </a>
        <div className="maker">
          <span>MADE BY SHIVAM</span>
          <span>V0.2.2 / 2026</span>
        </div>
      </header>

      <main id="top">
        <section className="hero">
          <div className="hero-meta">
            <span>PIANO COACH FOR MIDI</span>
            <span>MACOS / APPLE SILICON</span>
          </div>

          <h1>
            <span>PLAY.</span>
            <span>LISTEN.</span>
            <span>GET BETTER.</span>
          </h1>

          <div className="hero-bottom">
            <p>
              CODIANO HEARS EVERY KEY, SCORES THE ATTEMPT, AND TELLS YOU WHAT TO FIX—RIGHT AFTER YOU
              PLAY.
            </p>
            <div className="download-wrap">
              <Download platform={platform} />
              <span className="download-note">
                OPEN TERMINAL · PASTE · PRESS RETURN · NO APPLE ACCOUNT OR PASSWORD
              </span>
            </div>
          </div>
        </section>
      </main>

      <footer>
        <span>01 / MIDI INPUT</span>
        <span>02 / REAL FEEDBACK</span>
        <span>03 / YOUR SONGS</span>
        <span className="footer-status">LOCAL-FIRST ●</span>
      </footer>
    </div>
  )
}
